import {setTimeout} from "timers";

<template>
  <div class="mt-4">
    <v-container class="containerForRegister">
      <v-flex class="mx-auto max-width-big">

      </v-flex>
      <v-flex class="containerBackground max-width-big mx-auto">
        <v-container class="container_succes" grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card class="elevation-0 mb-4 mt-2 transparent">
                <v-layout justify-left>
                  <v-card
                    round
                    class=" left-in elevation-0 mt-1 ml-4"
                  >
                    <v-card-text>
                      <p
                        class="fontSize"
                        :style="getFontProperty()"
                      >{{$translate('LINDA_REGISTER_DONE')}}</p>
                      <p
                        class="fontSize2"
                        :style="getFontProperty()"
                      >{{$translate('LINDA_REGISTER_MAIL').replace(/accountName/g, $store.getters.getAccountInfo.AccountName)}}</p>
                      <p class="fontSize2"
                         :style="getFontProperty()"
                      >{{$translate('LINK_ACTIVATE_ACCOUNT')}}</p>

                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-card>
            </v-flex>
             <v-img
               class="passportImage"
               :src="require('../../assets/passportClosed.png')"></v-img>
          </v-layout>
        </v-container>
      </v-flex>
    </v-container>
  </div>
</template>
<script>
import * as dssRequest from "../../api/dssRequest.js";
import axios from "axios";
import Router from "vue-router";
import appConfig from "../../../config/app_config";
import { mapGetters } from "vuex";
import { ui_helpers } from "../../shared/ui_helpers";
import BaseComponent from "../base/BaseComponent.vue";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  computed: {
    ...mapGetters({
      _tripForm: "getTripForm",
      _customerPreferences: "getCustomerPreferences"
    })
  },
  data() {
    return {
      stepId: "",
      load: false,
      uniqueId: "",
      eventData: "",
      arrivalInfo: "",
      testEventData: ""
    };
  },
  created() {},
  mounted() {
    this.uniqueId = this.$route.params.uniqueId;
    // this.userType = this.$route.params.userType;
    this.stepId = this.$store.getters.getStepId;
  },
  methods: {
    goTo(page, params = "component") {

      // Generic function to let the user move to other component
      this.$router.push({
        name: page,
        params: params
      });
    },
    headerImage() {
      let fileType = ".png";
      let image = appConfig.mainImages.registerSuccesImage;
      if (image == null) {
        return;
      }
      return require("../../assets/" + image + fileType);
    },
    next() {
      return;
      this.stepId++;
      this.$store.dispatch("setStepId", 2);
      this.load = true;

      this.$router.push({
        name: "MainEventInfo",
        params: {
          uniqueId: this.userName
        }
      });
    },
    iOSAppStatus() {
      window.open(appConfig.IOSAppUrl.url, "_blank");
    },
    androidAppStatus() {
      window.open(appConfig.AndroindAppUrl.url, "_blank");
    }
  }
};
</script>
<style scoped>
.greyBorder {
  border: 2px solid #c0c0c0 !important;
}

.outlineMessage{
  margin-top: 4em;
  margin-left: 8em;
}

.buttonSmall {
  display: none;
}

.buttonBig {
  width: auto;
}

.castleImage {
  width: 100% !important;
}

.storeButton {
  width: auto;
  padding: 5px 0px 5px 0px;
}

.lindaLogo {
  height: 25em;
  margin-left: -5.5em;
}

.lindaText {
  max-height: 15em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px;
  max-width: 21em;
}

.fontSize {
  font-size: 18px;
}

.borderLeft {
  margin-bottom: 1.5em;
  border-left: 2px solid #c0c0c0;
}

.fontSize2 {
  font-size: 16px;
}

.tri-right.left-in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 30px;
  bottom: auto;
  border: 13px solid;
  border-color: #f2f2f2 #f2f2f2 transparent transparent;
}

.passportImage {
  margin: 9em;
  margin-top: auto;
  margin-bottom: auto;
}
.containerForRegister {
  height: 90vh;
}
</style>
